// extracted by mini-css-extract-plugin
export default {"avatar":"HomeImage_avatar__rFwOh","grid":"HomeImage_grid__neWaA"};